import { POST_AI_MARKUP_DATA, POST_AI_MARKUP_DATA_SUCCESS, POST_AI_MARKUP_DATA_FAIL, UPDATE_AI_MARKUP_DATA, GET_AI_MARKUP_DATA, GET_AI_MARKUP_DATA_SUCCESS, GET_AI_MARKUP_DATA_FAIL } from './actionTypes'

export const postMarkupData = (jsonData) => {
    return {
        type: POST_AI_MARKUP_DATA,
        payload: { jsonData }
    }
}

export const postMarkupDataSuccess = (tempData) => {
    return {
        type: POST_AI_MARKUP_DATA_SUCCESS,
        payload: { tempData }
    }
}

export const postMarkupDataFail = (tempData) => {
    return {
        type: POST_AI_MARKUP_DATA_FAIL,
        payload: { tempData }
    }
}

export const updateAIMarkupData = (jsonData) => {
    return {
        type: UPDATE_AI_MARKUP_DATA,
        payload: { jsonData }
    }
}

export const getMarkupData = (status) => {
    return {
        type: GET_AI_MARKUP_DATA,
        payload:status
    }
}

export const getMarkupDataSuccess = (tempData) => {
    return {
        type: GET_AI_MARKUP_DATA_SUCCESS,
        payload: { tempData }
    }
}

export const getMarkupDataFail = (tempData) => {
    return {
        type: GET_AI_MARKUP_DATA_FAIL,
        payload: { tempData }
    }
}
